<div class="section">
  <div class="title">Assegna socio esistente al gruppo</div>
  <form #assignSocioForm="ngForm" (ngSubmit)="assignSocio()">
    <div class="card">
      <div class="card-content fix-horizontal-form">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@memberIdUpper">Id socio</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="idSocio" type="number" min="0" max="2147483647" required
                  name="idSocioField">
              </div>
              <p class="help is-danger" *ngIf="assignSocioForm.submitted && !idSocio" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@cardIdUpper">Tessera</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="tessera" type="number" min="0" max="2147483647" required
                  name="tesseraField">
              </div>
              <p class="help is-danger" *ngIf="assignSocioForm.submitted && !tessera" i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>

        <div class="field has-text-right">
          <div class="control has-text-right">
            <button type="submit" class="button is-link" i18n="@@assign">Assegna</button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <hr />
  <div class="title" i18n="@@createMemberAndAssign">Crea socio e aggiungilo al gruppo</div>
  <form #addSocioForm="ngForm" (ngSubmit)="addSocio()">
    <div class="card">
      <div class="card-content fix-horizontal-form">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label"
              [ngClass]="{'has-text-danger' : nome1Field.invalid && (nome1Field.dirty || nome1Field.touched || addSocioForm.submitted)}"
              i18n="@@name">Nome</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.nome1" name="nome1FieldName" maxlength="127" required
                  type="text" #nome1Field="ngModel"
                  [ngClass]="{'is-danger' : nome1Field.invalid && (nome1Field.dirty || nome1Field.touched || addSocioForm.submitted)}">
              </div>
              <p class="help is-danger"
                *ngIf="nome1Field.invalid && (nome1Field.dirty || nome1Field.touched || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label"
              [ngClass]="{'has-text-danger' : nome2Field.invalid && (nome2Field.dirty || nome2Field.touched || addSocioForm.submitted) }"
              i18n="@@surname">Cognome</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.nome2" name="nome2FieldName" maxlength="127" required
                  type="text" #nome2Field="ngModel"
                  [ngClass]="{'is-danger' : nome2Field.invalid && (nome2Field.dirty || nome2Field.touched || addSocioForm.submitted)}">
              </div>
              <p class="help is-danger"
                *ngIf="nome2Field.invalid && (nome2Field.dirty || nome2Field.touched || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@birthDate"
              [ngClass]="{'has-text-danger' : dateField.invalid && (dateField.dirty || dateField.touched || addSocioForm.submitted)}">Data
              nascita</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control has-icons-right">
                <div class="control is-expanded">
                  <p-calendar [(ngModel)]="dateModel"
                    [inputStyleClass]="(dateField.invalid && (dateField.dirty || dateField.touched || addSocioForm.submitted)) ? 'input is-danger' : 'input'"
                    [yearRange]="yearRange" firstDayOfWeek="1" #dateField="ngModel" [required]="true" name="dateField"
                    dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true">

                  </p-calendar>
                </div>
                <p class="help is-danger"
                  *ngIf="dateField.invalid && (dateField.dirty || dateField.touched || addSocioForm.submitted)"
                  i18n="@@dataRequired">
                  Dato richiesto
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label"
              [ngClass]="{'has-text-danger' : luogoField.invalid && (luogoField.dirty || luogoField.touched || addSocioForm.submitted)}"
              i18n="@@birthPlace">Luogo nascita</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.luogoNascita" name="luogoFieldName" maxlength="50" required
                  type="text" #luogoField="ngModel"
                  [ngClass]="{'is-danger' : luogoField.invalid && (luogoField.dirty || luogoField.touched || addSocioForm.submitted)}">
              </div>
              <p class="help is-danger"
                *ngIf="luogoField.invalid && (luogoField.dirty || luogoField.touched || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@sex">Sesso</label>
          </div>
          <div class="field-body">
            <div class="field">
              <input class="is-checkradio" id="mField" type="radio" name="mField" value="M" [(ngModel)]="socio.sesso">
              <label for="mField" i18n="@@maleLabel">M</label>
              <input class="is-checkradio" id="fField" type="radio" name="fField" value="F" [(ngModel)]="socio.sesso">
              <label for="fField" i18n="@@femaleLabel">F</label>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal"
            [ngClass]="{'has-text-danger' : addressField.invalid && (addressField.dirty || addressField.touched || addSocioForm.submitted)}">
            <label class="label" i18n="@@address">Indirizzo</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.indirizzo" name="indirizzoFieldName" maxlength="255" required
                  type="text" #addressField="ngModel"
                  [ngClass]="{'is-danger' : addressField.invalid && (addressField.dirty || addressField.touched || addSocioForm.submitted)}">
              </div>
              <p class="help is-danger"
                *ngIf="addressField.invalid && (addressField.dirty || addressField.touched || addSocioForm.submitted || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@city"
              [ngClass]="{'has-text-danger' : cityField.invalid && (cityField.dirty || cityField.touched || addSocioForm.submitted)}">Città</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.citta" name="cittaFieldName" maxlength="100" required
                  type="text" #cityField="ngModel"
                  [ngClass]="{'is-danger' : cityField.invalid && (cityField.dirty || cityField.touched || addSocioForm.submitted)}">
              </div>
              <p class="help is-danger"
                *ngIf="cityField.invalid && (cityField.dirty || cityField.touched || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@zone"
              [ngClass]="{'has-text-danger' : provinciaField.invalid && (provinciaField.dirty || provinciaField.touched || addSocioForm.submitted)}">Provincia</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.provincia" name="provinciaFieldName" maxlength="2"
                  #provinciaField="ngModel" required type="text"
                  [ngClass]="{'is-danger' : provinciaField.invalid && (provinciaField.dirty || provinciaField.touched || addSocioForm.submitted)}">
              </div>
              <p class="help is-danger"
                *ngIf="provinciaField.invalid && (provinciaField.dirty || provinciaField.touched || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.cap" name="capFieldName" pInputText required pKeyFilter="pint"
                  maxlength="10" type="text" placeholder="CAP" i18n-placeholder="@@zipCode" #capField="ngModel"
                  [ngClass]="{'is-danger' : capField.invalid && (capField.dirty || capField.touched || addSocioForm.submitted)}">
              </div>
              <p class="help is-danger"
                *ngIf="capField.invalid && (capField.dirty || capField.touched || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@country" class="label"
              [ngClass]="{'has-text-danger' : countryField.invalid && (countryField.dirty || countryField.touched || addSocioForm.submitted)}">Nazione</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select"
                  [ngClass]="{'is-danger' : countryField.invalid && (countryField.dirty || countryField.touched || addSocioForm.submitted)}">
                  <select style="width:100%" name="nazioneField" [(ngModel)]="socio.codStato" required
                    #countryField="ngModel">
                    <option *ngFor="let nazione of nazioni" [ngValue]="nazione.twoLetterIsoCode">
                      {{nazione.twoLetterIsoCode}} - {{nazione.name}}
                    </option>
                  </select>
                </div>
              </div>
              <p class="help is-danger"
                *ngIf="countryField.invalid && (countryField.dirty || countryField.touched || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@taxCode"
              [ngClass]="{'has-text-danger' : (codFiscField.dirty || codFiscField.touched || addSocioForm.submitted) && (socio.codStato == 'IT' && !socio.codFiscale)}"
              class="label">Codice Fiscale</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.codFiscale" name="codFiscFieldName" type="text" maxlength="20"
                  #codFiscField="ngModel" [required]="(socio.codStato == 'IT') ? '' : null"
                  [ngClass]="{'is-danger' : (codFiscField.dirty || codFiscField.touched || addSocioForm.submitted) && (socio.codStato == 'IT' && !socio.codFiscale) }">
              </div>
              <p class="help is-danger"
                *ngIf="(codFiscField.dirty || codFiscField.touched || addSocioForm.submitted) && (socio.codStato == 'IT' && !socio.codFiscale)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Email</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.email" name="emailFieldName" type="text" email maxlength="50"
                  #emailField="ngModel">
              </div>
              <p class="help is-danger" *ngIf="emailField.invalid && (emailField.touched || addSocioForm.submitted)"
                i18n="@@mailNotValid">
                Email non valida
              </p>
            </div>
            <div class="field">
              <div class="control">
                <input type="checkbox" class="is-checkradio" id="newsletterCheckbox" [(ngModel)]="socio.newsletter"
                  [disabled]="!socio.email" name="newsLetterField">
                <label for="newsletterCheckbox">Newsletter</label>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@telephoneNumber" class="label">Telefono</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.telefono" name="telefonoFieldName" type="text" maxlength="255">
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@mobilePhoneNumber" class="label">Cellulare</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [(ngModel)]="socio.cellulare" maxlength="20" name="cellulareFieldName" type="text"
                  #cellField="ngModel">
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@association" class="label">Associazione</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select">
                  <select name="associazioneField" #associazioneField="ngModel" [ngModel]="socio.idAssociazione"
                    (ngModelChange)="onChangeAssociazione($event)">
                    <option [ngValue]="undefined" *ngIf="!socio.idAssociazione" i18n="@@selectInsurance">--Seleziona
                      associazione--</option>
                    <option [ngValue]="undefined" *ngIf="socio.idAssociazione" i18n="@@noInsurance">--Nessuna
                      associazione--</option>
                    <option *ngFor="let associazione of associazioni" [ngValue]="associazione.id">
                      {{associazione.ragioneSociale}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@cardAssociation"
              [ngClass]="{'has-text-danger' : socio.idAssociazione && tesseraAssociazioneField.invalid && (tesseraAssociazioneField.dirty || tesseraAssociazioneField.touched || addSocioForm.submitted)}">Tess.Ass.</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input" [disabled]="!socio.idAssociazione" [(ngModel)]="socio.tesseraAssociazione"
                  name="tesseraAssociazioneFieldName" type="text" #tesseraAssociazioneField="ngModel" maxlength="255"
                  [ngClass]="{'is-danger' : socio.idAssociazione && tesseraAssociazioneField.invalid && (tesseraAssociazioneField.dirty || tesseraAssociazioneField.touched || addSocioForm.submitted)}"
                  [required]="socio.idAssociazione ? '' : null">
              </div>
              <p class="help is-danger"
                *ngIf="socio.idAssociazione && tesseraAssociazioneField.invalid && (tesseraAssociazioneField.dirty || tesseraAssociazioneField.touched || addSocioForm.submitted)"
                i18n="@@dataRequired">
                Dato richiesto
              </p>
              <br />
              <p class="notification is-primary is-size-7" i18n="@@textDataIsCorrectNewSocioGroup">
                Il sottoscritto, consapevole della responsabilità in caso di dichiarazioni mendaci, attesta la
                veridicità e l'esattezza dei dati sopra dichiarati
              </p>
            </div>
          </div>
        </div>

        <div class="field is-grouped field is-grouped-right">
          <div class="control">
            <a [routerLink]="['/area-utente', 'gruppo']" i18n="@@cancel" class="button is-danger">Annulla</a>
          </div>
          <div class="control">
            <button type="submit" i18n="@@create" class="button is-primary">Crea</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>